import * as types from './mutation-types'
import api from '~/utils/api'
import { FORM_TYPE } from 'shared/AForm'
import { cachedRequest } from '@/utils/jobRequestApiMethods'
import { API_VERSION } from 'enums/api'

export const state = () => ({
  formsSettings: {}
})

function normalizeData(data) {
  const normalizedData = {}
  data.forEach(widgetSettings => {
    normalizedData[widgetSettings.Type] = widgetSettings
  })
  return normalizedData
}

export const getters = {
  getFormSettingsByType: ({ formsSettings }) => formType =>
    formsSettings[formType] || {}
}

export const actions = {
  async sendContactUsLead(_, { payload, captchaKey }) {
    try {
      const settings = {
        headers: { GoogleCaptchaResponseKey: captchaKey }
      }
      await this.$axios.post(api.leads.submitContactUsLead(), payload, settings)
    } catch (e) {
      throw e
    }
  },
  async requestFormsSettings({ commit, state }) {
    try {
      const { data } = await cachedRequest({
        method: this.$axios.get,
        args: [
          api.leads.getSubscriptionSettings(),
          {
            params: {
              types: Object.values(FORM_TYPE)
            }
          }
        ],
        apiVersion: API_VERSION.V1
      })
      commit(types.SET_WIDGETS_SETTINGS, normalizeData(data))
      return data
    } catch (e) {
      throw e
    }
  },
  async sendNewsletter({ dispatch, rootGetters }, { payload, captchaKey }) {
    try {
      const settings = {
        headers: { GoogleCaptchaResponseKey: captchaKey }
      }
      await this.$axios.post(
        api.leads.newsletterSubscription(),
        payload,
        settings
      )

      if (rootGetters['auth/isLoggedIn']) {
        await dispatch('auth/requestCurrentUserDetails', null, {
          root: true
        })
      }
    } catch (e) {
      throw e
    }
  },
  async requestExpertise() {
    try {
      const {
        data: { Expertises }
      } = await this.$axios.get(api.layout.getBecomeAContributerExpertises())
      return Expertises
    } catch (e) {
      throw e
    }
  },
  async requestBecomeAContributor(_, { payload, captchaKey }) {
    try {
      const settings = {
        headers: { GoogleCaptchaResponseKey: captchaKey }
      }
      await this.$axios.post(api.leads.becomeAContributor(), payload, settings)
    } catch (e) {
      throw e
    }
  },
  async requestBecomeAContributorFileUpload(_, payload) {
    try {
      const { data } = await this.$axios.post(
        api.leads.becomeAContributorFileUpload(),
        payload
      )
      return data
    } catch (e) {
      throw e
    }
  },
  async requestSubmitEbookLead(_, { payload, captchaKey }) {
    const settings = {
      headers: { GoogleCaptchaResponseKey: captchaKey }
    }

    try {
      const data = await this.$axios.post(
        api.leads.submitEbookLead(),
        payload,
        settings
      )
      return data
    } catch (e) {
      throw e
    }
  },
  async requestPhoneVerification(_, params) {
    try {
      const data = await this.$axios.post(api.leads.verifyPhone(), null, {
        params
      })
      return data
    } catch (e) {
      throw e
    }
  }
}

export const mutations = {
  [types.SET_WIDGETS_SETTINGS](state, settings) {
    state.formsSettings = settings
  }
}
